<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex padding-sm align-items-center justify-content-between catalogo-text text-sm text-sm"
          >
            Ubicacion
            <router-link :to="{ name: 'Ubicaciones' }">
              <CButton color="primary btn-header" class="mr-1">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>

          <CCardBody v-else>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.nombreUbicacion.$model"
                  :isValid="checkIfValid('nombreUbicacion')"
                  label="Nombre de la ubicación:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 25 caracteres"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Pertenece a:</label>
                <!-- <CSelect
                  :value.sync="ubicacion"
                  horizontal
                  :options="ubicaciones"
                  placeholder="Selecciona una ubicación"
                />-->
                <v-select
                  v-model="ubicacion"
                  :options="ubicaciones"
                  class="margin-multi"
                  :loading="isLoadingCombos"
                  placeholder="Selecciona una ubicación"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>
            <div class="mb-3" v-if="showSuspendido">
              <label class="mr-2">Estado:</label>
              <CSwitch :checked="!suspendido" @update:checked="toggleSuspendido()" class="mx-1" color="primary" variant="3d" />
              {{!suspendido?'Activo':'Suspendido'}}
            </div>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Cultivo:</label>
                <!-- <CSelect
                  :value.sync="cultivo"
                  horizontal
                  :options="cultivos"
                  placeholder="Selecciona una cultivo"
                />-->
                <v-select
                  v-model="cultivo"
                  class="margin-multi"
                  :options="cultivos"
                  :loading="isLoadingCombos"
                  placeholder="Selecciona una cultivo"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                  <!-- :value.sync="$v.nombreUbicacion.$model" -->
                  <!-- :isValid="checkIfValid('nombreUbicacion')" -->
                <CInput
                  v-if="cultivo"
                  type="number"
                  v-model="cantidad_plantas"
                  label="Cantidad de plantas"
                  placeholder="Cantidad de plantas..."
                />
              </CCol>
            </CRow>

            <ExtraConfigInput
              title=""
              parametro="ubicaciones_atributos_extras"
              v-model="fieldsExtra"
              @config="config => fieldsExtraConfig = config"
              @onValid="v=>valid=v"
            />
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="()=>{fetching=false}"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Ubicaciones' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger"
                >Cancelar</CButton
              >
            </router-link>

            <CButton
              @click="addUbicacion()"
              class="px-4 mx-3 btn-lg"
              color="success"
            >
              <div v-if="isLoading">
                <div
                  class="w-100 d-flex justify-content-center align-items-center"
                >
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
    <CModal
      size="sm"
      title="Ubicación"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
      >{{ error }}</CModal
    >
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import ExtraConfigInput from './../../customComponents/ExtraConfigInput.vue'


export default {
  name: "NuevoTrabajador",

  components: {
    ExtraConfigInput,
    vSelect
  },

  data() {
    return {
      id: this.$route.params.id,
      item: {},
      ubicacion: null,
      cultivo: null,
      nombreUbicacion: "",
      ubicaciones: [],
      isLoadingCombos: false,
      isLoading: false,
      isLoadingPage: false,
      warningModal: false,
      error: "",
      fieldsExtraConfig: [],
      fieldsExtra: {},
      cultivos: [],
      cantidad_plantas: 0,
      showSuspendido: true,
      suspendido: false,
      valid: {flag: true},
      fetching: false,
      medias:[],
    };
  },

  created() {
    const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->raiz_id",
            value: this.ubicacionRaizValue,
            operator: "="
          },
          {
            field: "payload->cultivo_id",
            value: 0,
            operator: "="
          },
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->cultivo_id",
            value: 0,
            operator: "="
          },
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    this.isLoadingPage = true;
    this.$store;

    const ubi = [
      this.$store.dispatch("customHTTP", { schema: "cultivos" }),
      // this.$store.dispatch("customHTTP", {
      //   schema: "ubicaciones",
      //   filter: {
      //     where: [
      //       {
      //         field: "payload->cultivo_id",
      //         value: 0,
      //         operator: "="
      //       }
      //     ]
      //   }
      // }),
      this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            },
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      })
    ];

    if (this.ubicacionRaizValue) {
      ubi.push(ubicacionTemplateRaiz);
    } else {
      ubi.push(ubicacionTemplateNoRaiz);
    }

    ubi.push(this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->pertenece_id",
              value: this.id,
              operator: "="
            },
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      }))

    Promise.all(ubi)
      .then(([cultivos, item, ubicaciones, children]) => {
        this.cultivos = cultivos.data.map(cultivo => {
          const variedad = cultivo.payload.variedad || ''
          return { value: cultivo.id, label: `${cultivo.payload.nombre} ${variedad}` };
        });
        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        this.item = item.data[0];
        this.medias = this.item.payload.anexos;
        this.suspendido = this.item.payload.suspendido;
        this.nombreUbicacion = this.item.payload.nombre;
        this.cantidad_plantas = this.item.payload.cantidad_plantas ? this.item.payload.cantidad_plantas : 0
        // this.ubicacion = this.item.payload.pertenece_id;
        this.ubicacion = this.ubicaciones.find(
          ubi => ubi.value == this.item.payload.pertenece_id
        );
        this.cultivo = this.item.payload.cultivo_id;
        this.ubicacion = this.ubicaciones.find(
          ubi => ubi.value == this.item.payload.pertenece_id
        );
        this.cultivo = this.cultivos.find(
          cul => cul.value == this.item.payload.cultivo_id
        );

        if(this.item.payload.extras !== undefined){
          let fieldsExtraPayload = Object.entries(this.item.payload.extras);
          for (let index = 0; index < fieldsExtraPayload.length; index++) {
            const fieldExtra = fieldsExtraPayload[index];
            this.fieldsExtra[fieldExtra[0]] = fieldExtra[1]
          }
        }
        // this.cultivo = this.item.payload.cultivo_id;
        if(children&&children.data?.length){
          this.suspendido = false
          this.showSuspendido = false
        }
      })
      .finally(() => (this.isLoadingPage = false));
  },

  mixins: [validationMixin],
  validations: {
    nombreUbicacion: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(25)
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  computed: {
    isValidUbicacion() {
      return !this.$v.nombreUbicacion.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  methods: {
    async pushMedia(files) {
      const arr = [];

      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;

        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
    async addUbicacion() {
      this.validateUbicacion();

      this.isLoading = true;
      this.fetching = true
      await (new Promise((res,)=>{
        const iter = setInterval(()=>{
          if(!this.fetching){
            this.error = ""
            clearInterval(iter)
            res()
          }
        },1000)
      }))
      this.isLoading = false;

      if(!this.valid.flag){
        const valores = this.valid.valores
        this.error = `Son requeridos los campos: ${valores.join(', ')}`;
        this.warningModal=true
        return
      }
      if (this.isValidUbicacion) {
        this.isLoading = true;

        // clean numbers extra fileds

        this.fieldsExtraConfig.forEach(indexField => {
          if (indexField.tipo === "number") {
            this.fieldsExtra[indexField.nombre] =
              Number(this.fieldsExtra[indexField.nombre]) || 0;
          }
          if (indexField.tipo === "text") {
            this.fieldsExtra[indexField.nombre] =
              this.fieldsExtra[indexField.nombre] || "";
          }
        });
        debugger
        const agregarUbicacion = {
            schema: "ubicaciones",
            id: this.id,
            payload: {
              nombre: this.nombreUbicacion,
              pertenece_id: this.ubicacion ? this.ubicacion.value : 0,
              cultivo_id: this.cultivo ? this.cultivo.value : 0,
              cantidad_plantas: this.cultivo ? parseInt(this.cantidad_plantas,10) : 0,
              suspendido: this.suspendido,
              anexos: this.medias,
            }
          }

        if (this.fieldsExtraConfig.length > 0) {
          agregarUbicacion.payload.extras = this.fieldsExtra;
        }
        this.$store
          .dispatch("customRemplazarHTTP", agregarUbicacion)
          .then(() => {
            // console.log(res.data);
            this.$router.push({ name: "Ubicaciones" });
          })
          .catch(rej => {
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    toggleSuspendido() {
      this.suspendido = !this.suspendido
    },
    validateUbicacion() {
      this.$v.nombreUbicacion.$touch();
    },
    updateCombos() {
      const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->cultivo_id",
              value: 0,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->cultivo_id",
              value: 0,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      this.isLoadingCombos = true;
      this.$store;

      const ubi = [];

      if (this.ubicacionRaizValue) {
        ubi.push(ubicacionTemplateRaiz);
      } else {
        ubi.push(ubicacionTemplateNoRaiz);
      }

      Promise.all(ubi)
        .then(([ubicaciones]) => {
          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });

          // this.cultivo = this.item.payload.cultivo_id;
        })
        .finally(() => (this.isLoadingCombos = false));
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
